/**
 * <LateMinutesPicker> — « Combien de retard ? » (molecule).
 *
 * Les cinq durées que le formulaire d'absence propose déjà (5 / 10 / 15 / 20 / 30 min), en
 * pilules qui passent à la ligne. Elle ne possède pas la sélection : `value` + `onChange`.
 *
 * Pilules de sélection (`<ChoiceChip variant="pill">`) : la forme du poussoir, mais un état choisi
 * / non choisi, pas une variante d'action — sur la nuit, le principal et le secondaire sont blancs
 * tous les deux.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { ChoiceChip } from "../../atoms/ChoiceChip"

/** Les valeurs du formulaire legacy — la liste ne se choisit pas par appelant. */
export const LATE_MINUTES_OPTIONS = [5, 10, 15, 20, 30]

export type LateMinutesPickerProps = {
    /** Minutes choisies, ou `null` tant que rien n'est choisi. */
    value: number | null
    onChange: (minutes: number) => void
    options?: number[]
    testID?: string
}

export function LateMinutesPicker(props: LateMinutesPickerProps) {
    const { value, onChange, options = LATE_MINUTES_OPTIONS, testID } = props

    return (
        <View style={styles.row} testID={testID}>
            {options.map((minutes) => (
                <ChoiceChip
                    key={minutes}
                    variant="pill"
                    label={`${minutes} min`}
                    selected={value === minutes}
                    onPress={() => onChange(minutes)}
                />
            ))}
        </View>
    )
}

const styles = StyleSheet.create((theme) => ({
    row: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: theme.spacing["2"],
    },
}))
